export const setFirstSymbolCase = (word, searchWord) => {
    const firstSymbol = searchWord[0];
    const isUpperCase = firstSymbol === firstSymbol.toUpperCase();
    if (isUpperCase && word) return word.charAt(0).toUpperCase() + word.slice(1);
    else return word
}